<template>
    <div id="home-images">
        <transition-group tag="ul" name="images">
            <li
                class="image-container"
                v-for="(i, index) in images"
                :key="index"
                v-show="index === imgIndex"
            >
                <div class="image" :style="{'background-image': 'url(' + i + ')'}"></div>
            </li>
        </transition-group>
    </div>
</template>

<script>

export default {
    name:'HomeImages',
    data() {
        return {
            imgIndex: 0,
            images: [
                require('../../assets/background/A01.webp'),
                require('../../assets/background/A02.webp'),
                require('../../assets/background/A03.webp'),
                require('../../assets/background/A04.webp'),
            ]
        }
    },
    methods: {
        play(){
            // Change the imgIndex per 4 seconds
            setInterval(() => {
                this.imgIndex = (this.imgIndex < this.images.length - 1) ? this.imgIndex + 1 : 0
            }, 4000);
        }
    },
    mounted(){
        this.play()
    },
}
</script>

<style scoped>
#home-images{
    height: 100vh;
    min-height: 600px;
    position: relative;
}

/* image-container styles */
.image-container{
    width: 100%;
    height: 600px;
    position: absolute;
}

/* image styles */
.image{
    height: 100vh;
    min-height: 600px;
    background: no-repeat center;
    background-size: cover;
}

/* Images Gradiention Animation */
.images-enter-active {
    transition: opacity 3s ease;
}
.images-leave-active {
    transition: 3s;
    z-index: -100;
}
.images-enter{
    opacity: 0;
}
.images-enter-to{
    opacity: 1;
}
</style>